<template>
	<sf-modal-layout class="qms-xxl" :title="cmpnMstPopupInfo.title" :show="display" :closeModal="close">
		<div class="sf-flex-column h-100">
			<sf-card class="p-0 border-0 bg-transparent">
				<pwa-apcn-popup-content ref="content" :scrId="scrId" @pwaSelectedRow="pwaSelectedRow"></pwa-apcn-popup-content>
			</sf-card>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
import PwaApcnPopupContent from './Content/PwaApcnPopupContent.vue';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			initState: false,
			display: false,
			cmpnMstPopupInfo: {
				title: '',
				pwaNo: ''
			},
			popUpType: '' //팝업호출구분값 :RO 또는 PWA
		};
	},
	components: {
		PwaApcnPopupContent
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async open(param) {
			this.display = true;
			this.cmpnMstPopupInfo.title = param.title;
			this.popUpType = param.popUpType;
			await this.DEFAULT_ASSIGN({
				key: 'popupSearchParams',
				value: {
					prcsRslt: '10',
					pwaNo: param.pwaNo,
					dlrCpnyCd: '',
					carVin: ''
				}
			});
			await this.$refs.content.PwaApcnListSearch();
		},
		close() {
			this.DEFAULT_ASSIGN({
				key: 'popupSearchParams',
				value: {
					prcsRslt: '10',
					pwaNo: '',
					dlrCpnyCd: '',
					carVin: ''
				}
			});
			this.display = false;
		},
		pwaSelectedRow(row) {
			/*row */
			if (this.popUpType == 'RO') {
				this.chkPmcIdCampNo_(row.pmcId)
					.then(response => {
						if (response.header.message != undefined && response.header.message != null) {
							let tmpCmpnNoList = '';
							if (response.body.result != undefined && response.header.message != null) {
								tmpCmpnNoList = convertNvl(response.body.result.cmpnNmList, '');
							}
							row.cmpnNoList = tmpCmpnNoList;

							this.$emit('pwaSelectedRow', row);
							this.close();
						}
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} else {
				this.$emit('pwaSelectedRow', row);
				this.close();
			}
		}
	}
};
</script>
